import React from 'react'
import "./Footer.css"
import { Link } from 'react-router-dom'
export default function Footer() {
  return (
    <footer>
      <div className='footer-column'>
      <img className='logoseparator' src="https://firebasestorage.googleapis.com/v0/b/revista1986-c6922.appspot.com/o/images%2Flogowhite.png?alt=media&token=706e0d00-11db-4af0-8522-3e447d9109ca" alt="" />
      </div>
        <div className='footer-column'>
          <p className='footer-text'>info@revista1986.com.ar</p>
          <p className='footer-text'>comercial@revista1986.com.ar</p>
          <p className='footer-text'>suscripciones@revista1986.com.ar</p>
          <p className='footer-text'>Teléfonos: +54 011 15 3654-3551 // 2024</p>
        </div>

        <div className='footer-column'>
      
          <Link onClick={() => {
            window.scrollTo(0, 0)
          }} to="/articulos/notas-de-tapa" className="footer-text">
                Notas de tapa{" "}
              </Link>
              <Link onClick={() => {
            window.scrollTo(0, 0)
          }} to="/articulos/historia" className="footer-text">
              Historia{" "}
              </Link>
              <Link onClick={() => {
            window.scrollTo(0, 0)
          }} to="/articulos/textos-millonarios" className="footer-text">
              Textos millonarios
              </Link>
              <Link onClick={() => {
            window.scrollTo(0, 0)
          }} to="/articulos/historias-monumentales" className="footer-text">
              Historias monumentales
              </Link>

        </div>

        <div className='footer-column'>
          <p className='footer-text'>Tienda 1986</p>
          <p className='footer-text'>Suscribite</p>
          <p className='footer-text'>Seguinos en redes</p>
          <p className='footer-row'>
          <img width="20" height="20" src="https://img.icons8.com/material-sharp/24/ffffff/twitterx--v1.png" alt="twitterx--v1"/>
          <img width="20" height="20" src="https://img.icons8.com/ios-glyphs/30/ffffff/youtube--v1.png" alt="youtube--v1"/>
          <img width="20" height="20" src="https://img.icons8.com/ios-glyphs/30/ffffff/instagram-new.png" alt="instagram-new"/>
          <img width="20" height="20" src="https://img.icons8.com/ios-filled/50/ffffff/facebook--v1.png" alt="facebook--v1"/>
 

          </p>
        </div>
    </footer>
  )
}
